import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material';
import { FileUploader } from 'ng2-file-upload';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ArquivoTermoService } from 'src/app/services/arquivo-termo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UploadService } from 'src/app/services/upload.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { ArquivoContratoService } from 'src/app/services/arquivo-contrato.service';
import { VariaveisArquivoContratoModalComponent } from '../variaveis-arquivo-contrato-modal/variaveis-arquivo-contrato-modal.component';
import { PremissasService } from 'src/app/services/premissas.service';

enum TipoArquivo {
  Pedido = 'pedido',
  Repasse = 'repasse',
}

// jquery
declare const $: any;

@Component({
  selector: 'app-arquivo-termo-modal',
  templateUrl: './arquivo-termo-modal.component.html',
  styleUrls: ['./arquivo-termo-modal.component.scss']
})
export class ArquivoTermoModalComponent implements OnInit {

  uploadForm: FormGroup;

  public config: PerfectScrollbarConfigInterface = {};

  uploader = new FileUploader({
    isHTML5: true
  });

  enviarArquivo: string;
  arquivosTermo = {
    repasse: false,
    pedido: false
  };

  existeArquivoContrato = false;

  pNomeContratoParceria = '';

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private dialogRef: MatDialogRef<ArquivoTermoModalComponent>,
    private uploadService: UploadService,
    private fb: FormBuilder,
    private arquivoTermoService: ArquivoTermoService,
    private utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    private arquivoContratoService: ArquivoContratoService,
    private premissaService: PremissasService,
  ) { }

  ngOnInit(): void {
    this.uploadForm = this.fb.group({
      document: [null, [Validators.required]]
    });
    this.buscarArquivosTermo();
    this.buscarArquivoContrato();
    this.buscarPremissaNomeContratoParceria();
  }

  buscarArquivosTermo() {
    this.carregandoService.mostra('buscarArquivosTermo');

    this.arquivoTermoService.consultarArquivosTermo().subscribe(
      (arquivosTermo) => {
        this.arquivosTermo = arquivosTermo;
        this.carregandoService.esconde('buscarArquivosTermo');
      },
      (erro) => {
        this.carregandoService.esconde('buscarArquivosTermo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaNomeContratoParceria() {
    this.carregandoService.mostra('buscarPremissaNomeContratoParceria');

    this.premissaService.consultarNomeContratoParceria().subscribe(
      (pNomeContratoParceria) => {
        this.pNomeContratoParceria = pNomeContratoParceria.valor;
        this.carregandoService.esconde('buscarPremissaNomeContratoParceria');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissaNomeContratoParceria');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarArquivoContrato() {
    this.carregandoService.mostra('buscarArquivoContrato');

    this.arquivoContratoService.existeArquivoContrato().subscribe(
      (existeArquivoContrato) => {
        this.existeArquivoContrato = existeArquivoContrato;
        this.carregandoService.esconde('buscarArquivoContrato');
      },
      (erro) => {
        this.carregandoService.esconde('buscarArquivoContrato');
        this.notificacaoService.erro(erro);
      }
    );
  }

  limparEnvio() {
    this.enviarArquivo = undefined;
    this.uploader.clearQueue();
    this.uploader.queue = [];
    this.uploadForm = this.fb.group({
      document: [null, [Validators.required]]
    });

    this.buscarArquivosTermo();
    this.buscarArquivoContrato();
  }

  baixarArquivo(tipo) {
    if(tipo === 'parceria') {
      this.baixarArquivoContrato();
      return;
    }

    this.carregandoService.mostra('baixarArquivo');
    this.arquivoTermoService.baixarPorTipo(tipo).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, 'termo_' + tipo + '.pdf');
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  baixarArquivoContrato() {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoContratoService.baixarArquivoContrato().subscribe(arq => {
      this.utilitarioService.saveBlob(arq, 'contrato_parceria.docx');
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  excluirArquivo(tipo) {
    if (tipo === 'parceria') {
      this.excluirArquivoContrato();
      return;
    }

    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Arquivo de termo de ' + (tipo === 'repasse' ? 'Repasse?' : 'Pedido?'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirArquivo');
        this.arquivoTermoService.excluirPorTipo(tipo).subscribe(() => {
          this.notificacaoService.sucesso('Arquivo de termo excluído com sucesso!!');

          this.limparEnvio();

          this.carregandoService.esconde('excluirArquivo');
        }, (erro) => {
          this.carregandoService.esconde('excluirArquivo');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  excluirArquivoContrato() {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Arquivo de Contrato de Parceria',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirArquivo');
        this.arquivoContratoService.excluirArquivoContrato().subscribe(() => {
          this.notificacaoService.sucesso('Arquivo de termo excluído com sucesso!!');

          this.limparEnvio();

          this.carregandoService.esconde('excluirArquivo');
        }, (erro) => {
          this.carregandoService.esconde('excluirArquivo');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  abrirModalVariaveis() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(VariaveisArquivoContratoModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
      },
      panelClass: 'modal-card'
    });
  }

  uploadSubmit() {
    for (let i = 0; i < this.uploader.queue.length; i++) {
      let fileItem = this.uploader.queue[i]._file;
      if (fileItem.size > 10000000) {
        alert('Cada arquivo deve possuir no máximo 10 MB.');
        return;
      }
    }

    let data = new FormData();

    for (let j = 0; j < this.uploader.queue.length; j++) {
      let fileItem = this.uploader.queue[j]._file;
      data.append('file', fileItem);
      data.append('fileSeq', 'seq' + j);
    }

    this.carregandoService.mostra('enviaArquivo');

    if(this.enviarArquivo === 'parceria') {
      this.arquivoContratoService.enviarArquivoContrato(data).subscribe((resp: any) => {
        this.notificacaoService.sucesso('Arquivo Enviado com Sucesso!!!');
        this.carregandoService.esconde('enviaArquivo');
        this.limparEnvio();
      }, (erro) => {
        this.carregandoService.esconde('enviaArquivo');
        this.notificacaoService.erro(erro);
      });

      this.uploader.clearQueue();
    } else {
      this.arquivoTermoService.enviarArquivoTermo(this.enviarArquivo, data).subscribe((resp: any) => {
        this.notificacaoService.sucesso('Arquivo Enviado com Sucesso!!!');
        this.carregandoService.esconde('enviaArquivo');
        this.limparEnvio();
      }, (erro) => {
        this.carregandoService.esconde('enviaArquivo');
        this.notificacaoService.erro(erro);
      });

      this.uploader.clearQueue();
    }

  }

  fechar() {
    this.dialogRef.close();
  }
}
